import styled from 'styled-components';

export const StyledEditWrapper = styled.div`
    display: flex;
    flex-direction: column;

    .edit-title {
        text-align: center;
        margin: 20px 0;
        font-size: 20px;
    }

    .inputs-wrapper {
        display: flex;
        margin-bottom: 10px;
        gap: 25px;

        .input {
            width: 100%;
            flex-grow: 1 0 auto;
        }

        .dropdown {
            width: 100%;
            flex-grow: 1 0 auto;
          }
    }

    .commission-error {
        color: red;
        text-align: start;
    }

    .bllink-button {
        margin-top: 20px;
        width: 300px;
        align-self: center;
    }
`
